// Helpers for handing row data to FastTable's search/filter Web Workers.
//
// The workers only ever read a handful of fields off each row:
//   - search.worker.js       -> row.id, row.cells, row.subrows
//   - filter-utils.js (filter) -> the above plus
//                                 row.object.company_security_profile_ids
//                                 row.object.warnings
//
// The rest of row.object (the full serialized document, employee and company)
// is dead weight. Since the mixins JSON-serialize the whole dataset on the main
// thread on every data change to strip Vue proxies before postMessage, slimming
// each row here is what makes that serialization cheap for large tables.

export function toWorkerData(data) {
    if (!data) {
        return []
    }

    return data.map(section =>
        (section || []).map(row => {
            const slim = {
                id: row.id,
                cells: row.cells,
                subrows: row.subrows,
            }

            if (row.object) {
                slim.object = {
                    company_security_profile_ids: row.object.company_security_profile_ids,
                    warnings: row.object.warnings,
                }
            }

            return slim
        })
    )
}
